module.exports = __webpack_public_path__ + "static/media/foldsofhonor.e2f4b3e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/foldsofhonor.png
// module id = 98
// module chunks = 0